import { OnDestroy } from '@angular/core';
import { VideoService } from './../../../../../services/video.service';
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { BagsSelect } from '@shared/interfaces/project/bags-select.interface';
import { Bags } from '@shared/interfaces/project/bags.interface';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ValidationRegEx } from '@shared/components/RegEx/regEx-list';
import { Project } from '@shared/models/project.model';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-description',
  templateUrl: './description.component.html',
  styleUrls: ['./description.component.scss'],
})
export class DescriptionComponent implements OnInit, OnDestroy {
  garbage: number[] = [
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 30, 40, 50, 60, 70, 80,
    90, 100,
  ];
  bagsSelect: BagsSelect[] = [
    {
      name: 'Plastic',
      type: 'plastic',
    },
    {
      name: 'Paper',
      type: 'paper',
    },
    {
      name: 'Metal',
      type: 'metal',
    },
    {
      name: 'Organic',
      type: 'organic',
    },
    {
      name: 'General',
      type: 'general',
    },
    {
      name: 'Glass',
      type: 'glass',
    },
    {
      name: 'E-waste',
      type: 'ewaste',
    },
  ];
  currentBagsSelect: BagsSelect[] = this.bagsSelect;
  @Input() bags: any = [];
  @Input() editMode: boolean = false;
  @Input() editProject: Project;
  @Input() formTrash: UntypedFormGroup;
  @Input() notAddedBags: boolean = false;
  loading: boolean = false;
  @Input() correctForm: UntypedFormGroup = null;
  public checkNumberLengthRef: (value) => void;
  videoLoading = false;
  correctVideoLinkSanitizer: SafeResourceUrl = null;
  @ViewChild('bagsSection', { static: true })
  bagsSection: ElementRef;

  subscription = new Subscription();
  displayBagCounter: boolean = false;

  constructor(
    public toast: ToastrService,
    public translate: TranslateService,
    public fb: UntypedFormBuilder,
    private readonly _videoService: VideoService,
    private readonly _domSanitizer: DomSanitizer
  ) {
    this.checkNumberLengthRef = (val) => this.checkNumberLength(val);
  }

  bagsSelectArray() {
    if (this.bags.value.length === 0) {
      return this.bagsSelect;
    }
    return this.bagsSelect.filter((el) => !this.bags.value.find((el2) => el.type === el2.type));
  }

  ngOnInit() {
    if (this.correctForm) {
      this.bags = this.fb.array(this.bags, [Validators.required]);
      this.correctForm.addControl('bags', this.bags);
    }
    this.currentBagsSelect = this.bagsSelectArray();
    this.subscription = this._videoService.videoLoading$.subscribe(
      (value) => (this.videoLoading = value)
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  correctVideoLink() {
    let url = this._videoService.correctVideoLink(this.correctForm.get('video').value);
    if (url) {
      this.correctVideoLinkSanitizer = this._domSanitizer.bypassSecurityTrustResourceUrl(url);
    }
  }

  createItem(pack): UntypedFormGroup {
    return this.fb.group({
      type: new UntypedFormControl(pack.type, [Validators.required]),
      size: new UntypedFormControl(pack.size, [Validators.required]),
      count: new UntypedFormControl(pack.count, [Validators.required]),
    });
  }

  updateGarbageBagsSelect(event) {
    // This is if at the time you added, and  inputs will be reset, but event change is work
    if (event.value) {
      this.formTrash.controls.bags.setValue(null);
    }
  }

  deleteTrash(index: number) {
    this.notAddedBags = true;
    this.bags.removeAt(index);
    this.currentBagsSelect = this.bagsSelectArray();
  }

  checkNumberLength(value) {
    // if starts at 0
    if (ValidationRegEx.startAtZero.regex.test(value)) {
      this.toast.error(this.translate.instant('PROJECT.bags_cant_start_at_zero'));
      return null;
    }
    // if input have symbols
    if (!ValidationRegEx.symbols.regex.test(value)) {
      this.toast.error(this.translate.instant('PROJECT.bags_input_cant_have_symbols'));
      return null;
    }
    // check max count for bags
    const num: number = +value;

    if (num <= 10000 && num > 0) {
      return value;
    }
    // if input not number
    if (isNaN(num)) {
      this.toast.error(this.translate.instant('PROJECT.bags_input_must_be_number'));
      return null;
    }
    this.toast.error(this.translate.instant('PROJECT.big_select_bags_number'));
    return null;
  }

  addTrash() {
    const value = { ...this.formTrash.value };
    const currentCountBags =
      this.bags.value.length > 0
        ? this.bags.value.map((el) => el.count).reduce((total, el) => +total + +el)
        : 0;
    if (+currentCountBags + +value.bags > 10000) {
      this.toast.error(this.translate.instant('PROJECT.big_select_bags_count'));
      return;
    }
    const pack: Bags = {
      type: value.type.type,
      size: 60,
      count: value.bags,
    };

    this.bags.push(this.createItem(pack));
    this.formTrash.reset();
    this.currentBagsSelect = this.bagsSelectArray();
  }

  isFromEcoHeroesEvent() {
    return this.editProject.categories.some((e) => e.id === 29);
  }
}
